import { Link, useNavigate } from "react-router-dom";
import { Header } from "../components/Header";
import { Breadcrumbs, PublicFooter } from "../components/PublicChrome";
import { useSeo, breadcrumbs, SITE_URL } from "../lib/seo";

const GUIDES = [
  {
    id: "designer", title: "How to use the designer", who: "For parents, players & individual orders",
    steps: ["Pick your sport and card layout", "Choose a background and tap a club colour palette", "Upload the photo – tap Remove background, drag and zoom to fit",
      "Add the name, rating, position and shirt number", "Enter the six statistics (0–100)", "Choose a size, save a draft and order"],
    cta: ["/design", "Open the designer"],
  },
  {
    id: "coach", title: "Coach guide: squad fundraiser", who: "For coaches, clubs & schools",
    steps: ["Create a coach account and a new squad", "Design the first player to set the club look and crest", "Quick-add the rest of the squad by name",
      "Copy the parent link and share it with parents", "Get alerts as parents finish – send one-tap reminders", "Download all shields or a squad poster for social media"],
    cta: ["/coach?mode=register", "Sign up your club"],
  },
];

export default function Help() {
  const nav = useNavigate();
  useSeo({ title: "How-to Videos – Shield Designer Guide | sportsshields.ie", path: "/help",
    description: "Watch two short walkthroughs: how to design a personalised player shield, and how coaches run a squad shield fundraiser.",
    jsonLd: { "@context": "https://schema.org", "@graph": [breadcrumbs([["Home", "/"], ["How-to videos", "/help"]]),
      ...GUIDES.map((g) => ({ "@type": "VideoObject", name: g.title, description: g.steps.join(". "), thumbnailUrl: `${SITE_URL}/videos/${g.id}-guide.jpg`,
        contentUrl: `${SITE_URL}/videos/${g.id}-guide.mp4`, uploadDate: "2026-06-20" }))] } });
  return (
    <div className="min-h-screen pb-16">
      <Header onNew={() => nav("/design")} />
      <main className="mx-auto max-w-6xl px-4 py-8 sm:px-6 lg:py-12">
        <Breadcrumbs items={[["Home", "/"], ["How-to videos", "/help"]]} />
        <div className="eyebrow mt-4">How-to videos</div>
        <h1 className="font-display text-4xl font-black uppercase leading-none tracking-tight sm:text-5xl">Watch & learn</h1>
        <p className="mt-2 max-w-xl text-sm text-slate-600">Two short walkthroughs: one for designing a shield and one for running a squad as a coach.</p>
        <div className="mt-10 space-y-14">
          {GUIDES.map((g) => (
            <section key={g.id} id={g.id} className="grid gap-8 lg:grid-cols-[1.6fr_1fr]" data-testid={`help-guide-${g.id}`}>
              <video controls preload="metadata" playsInline poster={`/videos/${g.id}-guide.jpg`} src={`/videos/${g.id}-guide.mp4`}
                className="w-full border-2 border-slate-900 bg-slate-900 shadow-[6px_6px_0_0_#0f172a]" data-testid={`help-video-${g.id}`} />
              <div>
                <div className="eyebrow">{g.who}</div>
                <h2 className="font-display mt-1 text-2xl font-black uppercase">{g.title}</h2>
                <ol className="mt-4 space-y-2.5">
                  {g.steps.map((s, i) => (
                    <li key={s} className="flex gap-3 text-sm"><span className="font-cond flex h-6 w-6 shrink-0 items-center justify-center bg-slate-900 text-sm font-bold text-lime-300">{i + 1}</span>{s}</li>
                  ))}
                </ol>
                <Link to={g.cta[0]} className="btn-blaze mt-6 inline-block px-5 py-2.5 text-sm" data-testid={`help-cta-${g.id}`}>{g.cta[1]}</Link>
              </div>
            </section>
          ))}
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
